export interface LoginRequest { //로그인 DTO
    username: string;
    password: string;
    keepLogin: boolean;
}

export interface LoginResponseData { //로그인 응갑 DTO
    id: number;
    accessToken: string;
    refreshToken: string;
    role: 'ADMIN' | 'CLIENT';
    isFirstTempLogin: boolean;
    optional: boolean;
}

export interface RegisterRequest { //회원가입 DTO
    companyName: string;
    username: string;
    email: string;
    password: string;
    businessNumber: string;
    name: string;
    managerName: string;
    position: string;
    phoneNumber: string;
    department: string;
    type: string;
    item: string;
    address: string;
    optional: boolean;
}

export interface AuthenticateRequest { //사업자등록번호 인증 DTO
    businesses: {
        b_no: string;
        start_dt: string;
        p_nm: string;
        b_nm: string;
    }[];
}

export interface PasswordResetRequest { //임시 비밀번호 발급 DTO
    email: string;
    businessNumber: string;
}

export interface AuthenticateResponseData { //사업자등록번호 인증 결과 DTO
    businessNumber: string;
    name: string;
    companyName: string;
}

export interface CheckResponseData { //이메일 인증 DTO
    email: string;
}

export const COOKIE_NAMES = { //리프레시 토큰
    REFRESH_TOKEN: 'refreshToken'
} as const;